import api from './config';

// Get all blog highlights (admin)
export const getBlogHighlights = async (params = {}) => {
  try {
    const response = await api.get('/blog-highlights', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get active blog highlights (public)
export const getActiveBlogHighlights = async () => {
  try {
    const response = await api.get('/blog-highlights/active');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single blog highlight
export const getBlogHighlight = async (id) => {
  try {
    const response = await api.get(`/blog-highlights/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Create new blog highlight
export const createBlogHighlight = async (formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await api.post('/blog-highlights', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update blog highlight
export const updateBlogHighlight = async (id, formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await api.put(`/blog-highlights/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete blog highlight
export const deleteBlogHighlight = async (id) => {
  try {
    const response = await api.delete(`/blog-highlights/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Toggle blog highlight active status
export const toggleBlogHighlightStatus = async (id) => {
  try {
    const response = await api.patch(`/blog-highlights/${id}/status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get blog highlight statistics
export const getBlogHighlightStats = async () => {
  try {
    const response = await api.get('/blog-highlights/stats');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
